window.addEventListener('load', function () {
    //Récupérer les champs de type password (js-champs-password-switcher)
    let champsPasswords = document.querySelectorAll('.js-champ-password-switcher');

    if(champsPasswords != null && champsPasswords.length > 0) {
        champsPasswords.forEach(function (champPassword) {
            //Récupérer le bouton de switch (js-champs-password-switcher-bouton)
            let boutonSwitch = champPassword.querySelector('.js-champ-password-switcher-bouton');

            if(boutonSwitch != null) {
                boutonSwitch.addEventListener('click', function (event) {
                    event.preventDefault();

                    //Récupérer le champ de type password
                    let champPasswordInput = champPassword.querySelector('input');

                    if(champPasswordInput != null) {
                        if(champPasswordInput.getAttribute('type') === 'password') {
                            champPasswordInput.setAttribute('type', 'text');
                        } else {
                            champPasswordInput.setAttribute('type', 'password');
                        }
                    }
                });
            }
        });
    }
});